import {
  getValueTransition,
  motion,
  useAnimation,
  useMotionValue,
} from "framer-motion";
import React, { useEffect } from "react";
import Logo from '../../media/LOGO_B.svg';

const CircularText = ({
  text = "Brighton * Brighton * Brighton * ",
  spinDuration = 20,
  w = 250
}) => {
  const lenght = text.length;
  const deg = 360 / lenght;
  const controls = useAnimation();
  const rotation = useMotionValue(0);
  useEffect(() => {
    const start = rotation.get();
    controls.start({
      rotate: start + 360,
      transition: getValueTransition(spinDuration, start),
    });
  }, [spinDuration, controls, rotation, text]);
  return (
    <div
      className={
        "relative flex items-center justify-center  rounded-full"
      }
      style={{width:`${w}px`, height:`${w}px`}}
    >
      <motion.div
        className="absolute w-full h-full m-0 text-2xl font-bold font-Bebas"
        animate={{ rotate: 360 }}
        transition={{ duration: 50, ease: "linear", repeat: Infinity }}
      >
        <p>
          {text.split("").map((letra, i) => (
            <span
              className="absolute top-0 left-1/2 text-secundario"
              key={i}
              style={{ transform: `rotate(${deg * i}deg)`,transformOrigin:`0px ${w/2}px` }}
            >
              {letra}
              
            </span>
          ))}
        </p>
      </motion.div>
        <span style={{width:`${w/1.5}px`, height:`${w/1.5}px`}} className="flex flex-col justify-center items-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[100px] h-[100px] bg-secundario rounded-full">
            <img src={Logo} width={500} className="w-full h-full object-cover" alt="Brighton English Center" />
        </span>
    </div>
  );
};

export default CircularText;
